import { combineReducers } from 'redux';
import environmentReducer from './environmentReducer';
import candidatesReducer from './candidatesReducer';
import activeReducer from './activeReducer';
import applicantsReducer from './applicantsReducer';
import interviewsReducer from './interviewsReducer';
import onboardingReducer from './onboardingReducer';
import cooldownReducer from './cooldownReducer';
import inactiveReducer from './inactiveReducer';
import passiveReducer from './passiveReducer';
import backlogReducer from './backlogReducer';
import profileReducer from './profileReducer';
import filterOptionsReducer from './filterOptionsReducer';
import companiesReducer from './companiesReducer';
import sidebarCountsReducer from './sidebarCountsReducer';
import uiReducer from './uiReducer';
import userReducer from './userReducer';
import companyManagerReducer from './companyManagerReducer';
import companyProfileReducer from './companyProfileReducer';
import positionTrackerReducer from './positionTrackerReducer';
import matchingReducer from './matchingReducer';
import opportunitiesReducer from './opportunitiesReducer';
import csReducer from './csReducer';
import referralsReducer from './referralsReducer';

const rootReducer = combineReducers({
  environment: environmentReducer,
  candidates: candidatesReducer,
  active: activeReducer,
  applicants: applicantsReducer,
  interviews: interviewsReducer,
  onboarding: onboardingReducer,
  cooldown: cooldownReducer,
  inactive: inactiveReducer,
  passive: passiveReducer,
  backlog: backlogReducer,
  referrals: referralsReducer,
  profile: profileReducer,
  filterOptions: filterOptionsReducer,
  companies: companiesReducer,
  sidebarCounts: sidebarCountsReducer,
  ui: uiReducer,
  user: userReducer,
  companyManager: companyManagerReducer,
  companyProfile: companyProfileReducer,
  positionTracker: positionTrackerReducer,
  matching: matchingReducer,
  opportunities: opportunitiesReducer,
  cs: csReducer,
});

export default rootReducer;
